import { Field, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { index, modelOptions, Prop } from '@typegoose/typegoose'
import { RelatedEntityObjectId } from '../base/RelatedEntityObjectId'
import { User } from '../user/User'
import type { DocumentLockKeyEnum } from './DocumentLockKeyEnum'

@ObjectType()
@InputType('DocumentLockInput')
@modelOptions({ schemaOptions: { timestamps: true } })
@index({ key: 1, value: 1 }, { unique: true, name: 'key_value_index' })
export class DocumentLock extends BaseEntity {
  @Field(() => Date)
  @Prop({ type: Date })
  tokenExpiryDate: Date

  @Field(() => String)
  @Prop({ type: String, index: true })
  key: DocumentLockKeyEnum

  @Field(() => String)
  @Prop({ type: String, index: true })
  value: string

  @Field(() => User)
  @Prop({ type: RelatedEntityObjectId })
  user: User

  //this is for the resolver only
  @Field(() => Boolean)
  isLocked: boolean
}
